import { Navigate, useLocation } from "react-router-dom";
import { authApi } from "@/lib/adminApi";

const ROLE_PERMISSIONS = {
  ADMIN: ["*"],
  PM: ["view", "new_entry", "reports"],
  APM: ["view", "new_entry", "reports"],
  FIELD_OFFICER: ["view", "new_dt_inspection"],
  CIRCLE_INCHARGE: ["view", "new_dt_inspection"],
};

export function normalizeRole(role) {
  const value = String(role || "").trim().toUpperCase();

  const legacyRoles = {
    SUPER_ADMIN: "ADMIN",
    ADMIN: "ADMIN",

    PROJECT_MANAGER: "PM",
    "PROJECT MANAGER": "PM",
    PM: "PM",

    ASSISTANT_PROJECT_MANAGER: "APM",
    "ASSISTANT PROJECT MANAGER": "APM",
    APM: "APM",

    FIELD_OFFICER: "FIELD_OFFICER",
    "FIELD OFFICER": "FIELD_OFFICER",

    CIRCLE_INCHARGE: "CIRCLE_INCHARGE",
    "CIRCLE INCHARGE": "CIRCLE_INCHARGE",
  };

  return legacyRoles[value] || value;
}

export function getUserPermissions(user) {
  const role = normalizeRole(user?.role);

  if (role === "ADMIN") {
    return ["*"];
  }

  const permissions = user?.permissions;

  if (Array.isArray(permissions) && permissions.length > 0) {
    return permissions.map((permission) =>
      String(permission).trim().toLowerCase()
    );
  }

  return ROLE_PERMISSIONS[role] || [];
}

export function hasPermission(user, permission) {
  if (!permission) return true;

  const permissions = getUserPermissions(user);
  const normalized = String(permission).trim().toLowerCase();

  return permissions.includes("*") || permissions.includes(normalized);
}

export default function AdminRoute({
  children,
  allowedRoles = [],
  requiredPermission = null,
  requireAdmin = false,
}) {
  const location = useLocation();
  const user = authApi.getCachedUser();
  const hasToken = authApi.hasToken();

  if (!hasToken || !user) {
    return (
      <Navigate
        to="/admin/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  const role = normalizeRole(user.role);

  if (requireAdmin && role !== "ADMIN") {
    return <Navigate to="/" replace />;
  }

  if (
    Array.isArray(allowedRoles) &&
    allowedRoles.length > 0 &&
    !allowedRoles.map(normalizeRole).includes(role)
  ) {
    return <Navigate to="/" replace />;
  }

  if (requiredPermission && !hasPermission(user, requiredPermission)) {
    return <Navigate to="/" replace />;
  }

  return children;
}